import { FileText, MapPin, Upload, Users } from "lucide-react";

export const packFormSteps = [
  { id: "location", label: "Location", description: "Pack details", icon: MapPin },
  { id: "users", label: "People", description: "Roles and shifts", icon: Users },
  { id: "forms", label: "Forms", description: "Required records", icon: FileText },
  { id: "uploads", label: "Attachments", description: "Supporting files", icon: Upload },
];